var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}}),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.loadingMsg))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }